import { TOPBAR_HEIGHT, useElementBorderBoxBlockSize } from '@capsicum/common-web';
import { HeaderWarning } from '@capsicum/features/regulations/web';
import { type ReactNode } from 'react';
import styled from 'styled-components';

import { WalletFrontPageStickyOffsetContext } from '../../hooks';
import { WalletHeader } from '../../ui';

export const WalletFrontPageLayout = ({
	children,
	headerContent
}: {
	children: ReactNode;
	headerContent: ReactNode;
}) => {
	const [warningRef, warningHeight] = useElementBorderBoxBlockSize();

	return (
		<S.Wallet>
			<S.StyledHeaderWarning horizontalPadding page="wallet" ref={warningRef} verticalPadding />
			<WalletHeader>{headerContent}</WalletHeader>
			<WalletFrontPageStickyOffsetContext.Provider value={TOPBAR_HEIGHT + warningHeight}>
				{children}
			</WalletFrontPageStickyOffsetContext.Provider>
		</S.Wallet>
	);
};

namespace S {
	export const Wallet = styled.div`
		display: flex;
		width: 100%;
		flex-direction: column;
	`;

	export const StyledHeaderWarning = styled(HeaderWarning)`
		background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
		top: ${TOPBAR_HEIGHT}px;
	`;
}
